import '@grandvisionhq/utils';
import { getUnlocalizedSpecificationItem } from '../../utils/get-unlocalized-specification-item.js';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '../../../../types/product.js';
import { getSpecificationItems } from '../../utils/get-specification-items.js';

const getSharedFrameSpecificationItems = ({ segment , trend , lensFeatures , frameFeatures , prescriptionGlass  })=>{
    const { lensColor , isGlazeble , isPolarized , isGradient , isMirror  } = lensFeatures || {};
    const { color: frameColor , colorAllLocales: frameColors , shape: frameShape , material: frameMaterial , materialAllLocales: frameMaterials , type: frameType , typeAllLocales: frameTypes , size: frameSize , templeType , templeColor ,  } = frameFeatures || {};
    const frameColorUnlocalized = getUnlocalizedSpecificationItem(frameColors);
    const frameMaterialUnlocalized = getUnlocalizedSpecificationItem(frameMaterials);
    const frameTypeUnlocalized = getUnlocalizedSpecificationItem(frameTypes);
    const frameShapeUnlocalized = getUnlocalizedSpecificationItem(frameShape === null || frameShape === void 0 ? void 0 : frameShape.displayNameAllLocales);
    const serverSpecifications = {
        segment,
        frameShape: frameShape === null || frameShape === void 0 ? void 0 : frameShape.displayName,
        frameShapeUnlocalized,
        lensColor,
        frameColor,
        frameColorUnlocalized,
        frameMaterial,
        frameMaterialUnlocalized,
        frameType,
        frameTypeUnlocalized,
        frameSize: frameSize === null || frameSize === void 0 ? void 0 : frameSize.displayName,
        isGlazeble,
        isPolarized,
        isMirror,
        isGradient,
        templeType,
        templeColor,
        trend,
        prescriptionGlass
    };
    return getSpecificationItems(serverSpecifications);
};

export { getSharedFrameSpecificationItems };
//# sourceMappingURL=get-shared-frame-specification-items.js.map
